// src/utils/axiosConfig.js

import axios from "axios";

// Create an instance of Axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://samandoon.com", // Set your API base URL
  headers: {
    "Content-Type": "application/json",
  },
  xsrfHeaderName: "X-CSRFToken", // Django's default CSRF header name
  xsrfCookieName: "csrftoken", // Django's default CSRF cookie name
});

// Optional: Add an interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally (e.g., log them or show a toast)
    // console.error("API call failed: ", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
